import dateformat from "dateformat";
import ReactHtmlParser from "react-html-parser";
import axios from "axios";

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function formatDateToNames(date) {
  let usFormat = null;
  if (date.indexOf('/') === -1) {
    usFormat = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4)
  } else {
    usFormat = formatDateToUs(date);
  }

  return dateformat(usFormat, "ddd[] d [/]mmm");
}

export function customWSPDateFormat(date) {
  return ReactHtmlParser(
    formatDateToNames(date)
      .replace("[]", "<span>")
      .replace("[/]", "</span>")
  );
}

export function formatDateToUs(date) {
  const chunks = date.split("/");
  return `${chunks[1]}/${chunks[0]}/${chunks[2]}`;
}

export function getMonthNumberFromName(month) {
  return months.map((m) => m.toLowerCase()).indexOf(month.toLowerCase()) + 1;
}

export function getMonthNameFromNumber(month) {
  return months[month - 1];
}

export function UKDateToTimestamp(date) {
  return new Date(formatDateToUs(date)).valueOf();
}

export function DBDateToTimestamp(date) {
  return new Date(date.substr(0,4), date.substr(4,2) - 1, date.substr(6,2)).valueOf();
}

export const filterDuplicates = (item, i, arr) => {
  if (typeof item === "string") {
    return arr.map((a) => a.toLowerCase()).indexOf(item.toLowerCase()) === i;
  } else {
    return arr.map((a) => a).indexOf(item) === i;
  }
};

export const makeDateKey = (year, month) => {
  let key = "" + year;
  key += (month < 10) ? "0" : "";
  key += month;
  return key;
}

export const validPostcode = (string) => {
  return string.match(/^((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) ?([0-9][A-Za-z]{2})?)$/) !== null
}

export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371e3; // metres
  const φ1 = lat1 * Math.PI/180; // φ, λ in radians
  const φ2 = lat2 * Math.PI/180;
  const Δφ = (lat2-lat1) * Math.PI/180;
  const Δλ = (lon2-lon1) * Math.PI/180;

  const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ/2) * Math.sin(Δλ/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

  const d = R * c; // in metres
  return d / 1609.34; // in miles
}

export function geocode(address) {
  if (address && address.length > 0) {
    const access_token = process.env.GATSBY_MAPBOX_ACCESS_TOKEN;
    if (!access_token) {
      console.warn('No Mapbox access token set');
      return Promise.resolve(null);
    }
    address = encodeURIComponent(address);
    const url = `https://api.mapbox.com/search/geocode/v6/forward?access_token=${access_token}&q=${address}&country=GB&types=postcode&limit=1`;
    return axios.get(url)
      .then((response) => {
        if (response.data && response.data.features && response.data.features.length > 0) {
          const feature = response.data.features[0];
          if (feature.geometry && feature.geometry.coordinates && feature.geometry.coordinates.length === 2) {
            return {
              longitude: feature.geometry.coordinates[0],
              latitude: feature.geometry.coordinates[1],
              full_address: feature.properties.full_address
            };
          }
        }
        return null;
      })
    .catch((error) => {
      console.error('Error geocoding address:', error);
      return null;
    });
  } else {
    console.log('no address to geocode');
    return Promise.resolve(null);
  }
}

/**
 * Get the distance matrix between an origin and multiple locations
 * @param {Object} origin
 * @param {number} origin.latitude
 * @param {number} origin.longitude
 * @param {Object[]} locations
 * @param {number} locations[].latitude
 * @param {number} locations[].longitude
 * @description Uses the Mapbox Matrix API to get road distances between an origin and multiple locations.
 * @see https://docs.mapbox.com/api/navigation/matrix/
 * @returns {Promise<Object[]>} locations with roadDistance property added in miles
 */
export function getDistanceMatrix(origin, locations) {
  const access_token = process.env.GATSBY_MAPBOX_ACCESS_TOKEN;
  if (!access_token) {
    console.warn('No Mapbox access token set');
    return Promise.resolve(null);
  }
  const source = origin.longitude + "," + origin.latitude;

  // don't add locations more than once to the request
  let uniqueLocations = [];
  let locationsMap = []; // uniqueLocationsIndex => [locationIndex, locationIndex, ...]

  locations.map((location, locationIndex) => {
    const value = location.longitude + ',' + location.latitude;
    const key = uniqueLocations.indexOf(value);
    if (key === -1) {
      // not seen this location yet, add it
      uniqueLocations.push(value);
      locationsMap.push([locationIndex]);
    } else {
      // have seen this location, add it to the map
      locationsMap[key].push(locationIndex);
    }
  });

  const destinations = uniqueLocations.slice(0, 24).join(";");
  const url = `https://api.mapbox.com/directions-matrix/v1/mapbox/driving/${source};${destinations}?access_token=${access_token}&annotations=distance&sources=0`;
  return axios.get(url)
    .then((response) => {
      if (response.data && response.data.distances) {
        for (let i = 1; i < response.data.distances[0].length; i++) {
          const roadDistance = response.data.distances[0][i] / 1609.34;

          locationsMap[i - 1].map((locationIndex) => {
            locations[locationIndex].roadDistance = roadDistance;
          });
        }
      }
      return locations;
    })
    .catch((error) => {
      console.error('Error getting distance matrix:', error);
      return null;
    });
}
